import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createAndFireEvent } from '@atlaskit/analytics-next';
import { UI_EVENT_TYPE, OPERATIONAL_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
var packageName = "@atlaskit/reactions";
var packageVersion = "31.6.1";
/**
 * TODO: move to utility package?
 * A random sampling function
 * sampling algorithm is from @atlassian/jira-coinflip at https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/browse/src/packages/platform/app-framework/coinflip/src/index.tsx
 * E.g. isSampled(2) will pass 50% of the time
 * @param rate The chance that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */
// default sampling function to determine which one to be sampled
export var isSampled = function isSampled(rate) {
  if (rate === 1) {
    return true;
  }
  if (rate === 0) {
    return false;
  }
  return Math.random() * rate <= 1;
};
export var createAndFireEventInElementsChannel = createAndFireEvent('fabric-elements');
export var createAndFireSafe = function createAndFireSafe(createAnalyticsEvent, creator) {
  if (createAnalyticsEvent) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    createAndFireEventInElementsChannel(creator.apply(void 0, args))(createAnalyticsEvent);
  }
};
var createPayload = function createPayload(action, actionSubject, eventType, actionSubjectId) {
  return function () {
    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      action: action,
      actionSubject: actionSubject,
      eventType: eventType,
      actionSubjectId: actionSubjectId,
      attributes: _objectSpread(_objectSpread({}, attributes), {}, {
        packageName: packageName,
        packageVersion: packageVersion
      })
    };
  };
};
var calculateDuration = function calculateDuration(startTime) {
  return startTime ? Date.now() - startTime : undefined;
};
var getPreviousState = function getPreviousState(reaction) {
  if (reaction) {
    if (reaction.reacted) {
      return 'existingReacted';
    }
    return 'existingNotReacted';
  }
  return 'new';
};
export var createRestSucceededEvent = function createRestSucceededEvent(actionSubject) {
  return createPayload('succeeded', actionSubject, OPERATIONAL_EVENT_TYPE)();
};
export var createRestFailedEvent = function createRestFailedEvent(actionSubject, errorCode) {
  return createPayload('failed', actionSubject, OPERATIONAL_EVENT_TYPE)({
    errorCode: errorCode
  });
};
export var createReactionsRenderedEvent = function createReactionsRenderedEvent(startTime) {
  return createPayload('rendered', 'reactionView', OPERATIONAL_EVENT_TYPE)({
    duration: calculateDuration(startTime)
  });
};
export var createPickerButtonClickedEvent = function createPickerButtonClickedEvent(reactionEmojiCount) {
  return createPayload('clicked', 'reactionPickerButton', UI_EVENT_TYPE)({
    reactionEmojiCount: reactionEmojiCount
  });
};
export var createPickerCancelledEvent = function createPickerCancelledEvent(startTime) {
  return createPayload('cancelled', 'reactionPicker', UI_EVENT_TYPE)({
    duration: calculateDuration(startTime)
  });
};
export var createPickerMoreClickedEvent = function createPickerMoreClickedEvent(startTime) {
  return createPayload('clicked', 'reactionPicker', UI_EVENT_TYPE, 'more')({
    duration: calculateDuration(startTime)
  });
};
export var createReactionSelectionEvent = function createReactionSelectionEvent(source, emojiId, reaction, startTime) {
  return createPayload('clicked', 'reactionPicker', UI_EVENT_TYPE, 'emoji')({
    duration: calculateDuration(startTime),
    source: source,
    previousState: getPreviousState(reaction),
    emojiId: emojiId
  });
};
export var createReactionHoveredEvent = function createReactionHoveredEvent(startTime) {
  return createPayload('hovered', 'existingReaction', UI_EVENT_TYPE)({
    duration: calculateDuration(startTime)
  });
};
export var createReactionFocusedEvent = function createReactionFocusedEvent(startTime) {
  return createPayload('focused', 'existingReaction', UI_EVENT_TYPE)({
    duration: calculateDuration(startTime)
  });
};
export var createReactionClickedEvent = function createReactionClickedEvent(added, emojiId) {
  return createPayload('clicked', 'existingReaction', UI_EVENT_TYPE)({
    added: added,
    emojiId: emojiId
  });
};

/**
 * Used for store failure metadata for analytics
 * @param error The error could be a service error with {code, reason} or an Error
 * @returns any
 */
export var extractErrorInfo = function extractErrorInfo(error) {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message
    };
  }
  return error;
};